var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3594 1.75781C16.2176 1.75781 14.3562 2.73818 12.9763 4.59287C12.799 4.8312 12.6406 5.06963 12.5 5.30093C12.3594 5.06958 12.2011 4.8312 12.0237 4.59287C10.6438 2.73818 8.78237 1.75781 6.64062 1.75781C2.67412 1.75781 0 4.94399 0 8.8502C0 13.9481 4.84531 17.1577 11.8748 23.0158C12.0559 23.1667 12.2779 23.2422 12.5 23.2422C12.7221 23.2422 12.9441 23.1667 13.1252 23.0158C20.153 17.1593 25 13.9488 25 8.8502C25 4.94629 22.3282 1.75781 18.3594 1.75781ZM12.5 20.9963C6.02725 15.6414 1.95312 12.8035 1.95312 8.8502C1.95312 6.29634 3.56328 3.71094 6.64062 3.71094C8.14448 3.71094 9.41709 4.38481 10.4231 5.71392C11.2202 6.76699 11.5515 7.85386 11.5622 7.8894C11.6832 8.30659 12.0654 8.59375 12.5 8.59375C12.9353 8.59375 13.318 8.30571 13.4384 7.88745C13.4504 7.8457 14.6838 3.71094 18.3594 3.71094C21.4367 3.71094 23.0469 6.29634 23.0469 8.8502C23.0469 12.8073 18.9522 15.6586 12.5 20.9963Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.1d51fd3d19b61319d2a8468a6ef27811.svg";
export { ForwardRef as ReactComponent };